import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { XCircle, ShieldCheck } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen bg-background text-foreground grid-texture flex items-center justify-center p-6">
      <motion.div initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} className="w-full max-w-md border border-border bg-background p-10 text-center" data-testid="payment-cancel-card">
        <Link to="/" className="inline-flex items-center gap-2 mb-8">
          <div className="h-7 w-7 bg-primary flex items-center justify-center"><ShieldCheck className="h-4 w-4 text-white" /></div>
          <span className="font-heading text-lg font-extrabold tracking-tighter">VAULTVEC</span>
        </Link>
        <div className="flex justify-center mb-6"><XCircle className="h-12 w-12 text-muted-foreground" /></div>
        <h1 className="font-heading text-2xl font-bold tracking-tight">Checkout cancelled</h1>
        <p className="text-sm text-muted-foreground mt-3 leading-relaxed">No charge was made. You can pick a plan again whenever you're ready.</p>
        <div className="mt-8 flex flex-col gap-3">
          <Link to="/#pricing">
            <Button className="w-full rounded-none bg-primary hover:bg-primary/90 text-white h-11">View plans</Button>
          </Link>
          <Link to="/">
            <Button variant="outline" className="w-full rounded-none border-border h-11">Back to home</Button>
          </Link>
        </div>
      </motion.div>
    </div>
  );
}
